import React, { useEffect, useState } from "react";
import "./ExistingHutchForm.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import BASE_URL, { API_KEY, PAYLOAD_SECRET } from "../../../../config";
import { useProcessContext } from "../../../context/ProcessContext";
import { BallTriangle } from "react-loader-spinner";

const Authorize = () => {
  const { centerAlert, userData, encryptData } = useProcessContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [showKey, setShowKey] = useState(false);
  const [loading, setLoading] = useState(false);
  const [configureData, setConfigureData] = useState({
    userId: userData.userid,
    configName: userData.username,
    configType: "baseUrl",
    parameter: "",
    database: "",
    databasetype: "odoo.sh",
    securitykey: "",
    license_key: "",
    client_rule_engine: false,
    odoo_version: "",
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    setConfigureData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value?.trim(),
    }));
  };

  //   method for reset form
  const handleResetForm = () =>
    setConfigureData({
      userId: userData.userid,
      configName: userData.username,
      configType: "baseUrl",
      parameter: "",
      database: "",
      databasetype: "odoo.sh",
      securitykey: "",
      license_key: "",
      client_rule_engine: false,
      odoo_version: "",
    });


  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const code = params.get("code");

  //   if (code) {
  //     sendCode(code);
  //   }
  // }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const type = params.get("type");

    if (code && type) {
      sendCode(code, type);
    }
  }, [location.search]);

  const sendCode = async (code, type) => {
    setLoading(true);
    const userId = configureData.userId;
    try {
      const response = await fetch(
        `${BASE_URL}/odoosh/code?user_id=${encodeURIComponent(userId)}&git_code=${encodeURIComponent(code)}&type=${encodeURIComponent(type)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      console.log("API Response in sending code:", data);
      if (data.code === 200) {
        centerAlert("success", "We'll redirect to install apps");
        navigate("/configuration/choose-repo", { state: { repoData: data.message, temp: data.temp, code: data.code } });
        setLoading(false);
      } else if (data.code === 600) {
        centerAlert("error", data.message);
        setLoading(false);
      } else {
        centerAlert("error", data.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error calling API:", error);
    }
  };

  const handleAuthorize = async (e) => {
    e.preventDefault();
    setLoading(true);
    const type = "authorize"
    try {
      const userId = configureData.userId;
      const response = await fetch(`${BASE_URL}/odoosh/validate?user_id=${encodeURIComponent(userId)}&type=${encodeURIComponent(type)}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        localStorage.setItem('type', type);
        const data = await response.json();
        setLoading(false);
        console.log("response data in authorizer =================", data);
        // window.open(data.message, '_blank', 'noopener,noreferrer');
        window.location.href = data.message;
        // centerAlert("success", data.message);
      } else {
        const data = await response.json();
        setLoading(false);
        centerAlert("error", data.message);
        console.error("Error creating data:", data);
      }
    } catch (error) {
      setLoading(false);
      centerAlert("error", error.message);
      console.error("Network error:", error);
    }
  };

  // console.log("configureData::: ", configureData);

  return (
    <div
      className="d-flex flex-column align-items-center"
      style={{ width: "100%", height: "100%", backgroundColor: "white" }}
    >
      {loading && (
        <div
          className="progress_bar_checkin"
          style={{ width: "350px", height: "250px", top: "40%" }}
        >
          {/* Loading */}
          <h3>Processing...</h3>
          {/* <ProgressBar progress={progress} /> */}
          <BallTriangle
            height={100}
            width={100}
            radius={5}
            color="#1a7e8f"
            ariaLabel="ball-triangle-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      )}
      <div className="configure_page_container">
        <form className="configure_page_form" onSubmit={handleAuthorize}>
          <h2 style={{ marginBottom: '20px' }}>Authorize Odoo.sh</h2>
          <div style={{ textAlign: "start", fontSize: "16px", lineHeight: "1.5", minHeight: '200px' }}>
            <p style={{ margin: "10px 0" }}>Connect your GitHub account to get started! We’ll securely access your repositories and help you manage everything in one place.</p>
            <p style={{ margin: "10px 0" }}>Authorize GitHub access to unlock seamless integration with your repositories. Let’s get you set up!</p>
          </div>
          {/* <div
            className="mb-3 d-flex justify-content-center align-items-center gap-3"
            style={{ width: "100%", minHeight: '200px', flexDirection: 'column' }}
          >
            <h5>Connect your GitHub account to get started! We’ll securely access your repositories and help you manage everything in one place.</h5>
            <h5>Authorize GitHub access to unlock seamless integration with your repositories. Let’s get you set up!"</h5>
          </div> */}

          <div className="d-flex justify-content-center align-items-center gap-3">
            <button
              type="submit"
              className="btn my-3"
              style={{ backgroundColor: "#1a7e8f", color: "white" }}
            >
              Authorize
            </button>
            {/* <button
              type="submit"
              className="btn my-3"
              style={{ backgroundColor: "#fff", color: "#1a7e8f", border: '1px solid #1a7e8f' }}
            >
              Authorize
            </button> */}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Authorize;
